// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"23da3d91","484":"85992b56","551":"aaaaf1ad","974":"5956f516"}[chunkId] + ".chunk.js";
};